module.exports = __webpack_public_path__ + "static/machine04-sq-73f59d1f8e21895261566eedf53d7646.png";